import { getMessageForError } from '../helpers/validationHelpers';

export default {
  inject: ['$validator'],

  /**
   * The .invalid class is added to the input and textarea when it fails
   * validation. This classname is available in the global CSS file.
   */
  data() {
    const inputInline = 'inputInline';
    const invalid = 'invalid';
    return { inputInline, invalid };
  },

  methods: {
    handleError() {
      return getMessageForError(this.v2Errors, this.name);
    },

    valueChange(event) {
      this.$emit(event.type, event.target.value, this.v2Errors, event);
      if (this.v2Errors.has(this.name)) {
        this.$validator.validate(this.name);
      }
    },
  },

  props: {
    autocomplete: {
      type: String,
      default: null,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    dataLpignore: {
      type: [String, Boolean],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorStyleExceptions: {
      type: [String, Array],
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    maxlength: {
      type: [Number, Boolean],
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: [String, Boolean],
      default: false,
    },
    readonly: {
      type: [String, Boolean],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    scope: {
      type: String,
      default: null,
    },
  },
};
